export let CONSTANT = {
  SERVER_PATH: null,

  APPLICATION_VERSION : "0.0.00000000",

  DEFAULT_LANGUAGE: "en-US",
  DEFAULT_ROOT_SCREENID: "CMS020",

  PAGE_STEP: 5,
  DISPLAY_PAGE: 20,

  GOOGLE_LOCATION_API_KEY: "AIzaSyAUQ3yqw0jUuJqmdjNVZB0WpuLjjFInOoY",

  DEFAULT_GROUP_CHECKER: 3
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_custom/models/constant.ts